// polyfill
import 'babel-polyfill'
// Vue
import Vue from 'vue'
import App from './App'
// store
import store from '@/store/index'
// 模拟数据
import '@/mock'
// 多国语
import i18n from './i18n'
// 核心插件
import d2Admin from '@/plugin/d2admin'
// 路由
import router from './router'
// qiniu
import * as qiniu from 'qiniu-js'
// 富文本编辑
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme
import '@/assets/css/global.less'
import util from '@/libs/util'
import { findBestTopMenu } from '@/layout/header-aside/utils/menuMatch'

import vueAplayer from 'vue-aplayer'
// import Clipboard from 'clipboard'
// Vue.use(Clipboard)

import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

import VueDragResize from 'vue-drag-resize'

import axios from 'axios'
import { getToken } from '@/api/demo/classification'
Vue.use(VueQuillEditor /* { default global options } */)

Vue.use(vueAplayer)

Vue.use(VideoPlayer)
Vue.component('vue-drag-resize', VueDragResize)
Vue.prototype.$axios = axios // 全局注册，使用方法为:this.$axios
// in your entrypoint
// 核心插件
Vue.use(d2Admin, { store })
console.log('process.env.VUE_APP_API', process.env.VUE_APP_API)
// 启动时将 VUE_APP_API 存入 cookie
util.cookies.set('VUE_APP_API', process.env.VUE_APP_API)

Vue.directive('debounce', {
  inserted (el, binding, vnode) {
    let timer = {}
    el.addEventListener('click', () => {
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => {
        binding.value()
      }, 200)
    })
  }
})
// export const debounce = (fn,t)=>{
//   const delay = t || 200
//   let timer
//   return function(){
//     const args = arguments
//     if(timer){
//       clearTimeout(timer)
//     }
//     timer = setTimeout(()=>{
//       timer = null
//       fn.apply(this,args)
//     },delay)
//   }
// }
getToken({}).then(res => {
  Vue.prototype.$qiniu = {}
  Vue.prototype.$qiniu.token = res.token
  Vue.prototype.$qiniu.domain = res.domain
  console.log('Vue.prototype.$qiniu.domain ', Vue.prototype.$qiniu.domain)
})
new Vue({
  router,
  store,
  i18n,
  qiniu,
  render: (h) => h(App),
  created () {},
  mounted () {
    // 展示系统信息
    this.$store.commit('d2admin/releases/versionShow')
    // 用户登录后从数据库加载一系列的设置
    this.$store.dispatch('d2admin/account/load')
    // 获取并记录用户 UA
    this.$store.commit('d2admin/ua/get')
    // 初始化全屏监听
    this.$store.dispatch('d2admin/fullscreen/listen')
  },
  watch: {
    '$route.path' (currentPath) {
      const fullAside = this.$store.state.d2admin.menu.fullAside
      const matchedMenu = findBestTopMenu(fullAside, currentPath)
      this.$store.commit(
        'd2admin/menu/asideSet',
        matchedMenu && Array.isArray(matchedMenu.children) ? matchedMenu.children : []
      )
    }
  }
}).$mount('#app')
